export interface IntercomData {
    userHash: string;
    registrationEpoch: number;
    email: string;
    id: string;
    name: string;
    hasUserflow: boolean;
}

export interface MapView {
    center: [number, number];
    zoom: number;
}

export interface Branding {
    color: string;
    background: string;
    name: string | null;
    email: string | null;
    personalPhoto: string | null;
    companyName: string | null;
    companyLogo: string | null;
    cellPhone: string | null;
    url: string | null;
    fax: string | null;
    officeLocation: string | null;
    officePhone: string | null;
    slogan: string | null;
    banner: string | null;
    agentPhoto: string | null;
    agentInfoName: string | null;
    agentInfoContent: string | null;
    reportType: 'empty' | 'banner' | 'info';
    summaryType: 'empty' | 'banner' | 'info';
    featureSheetType: 'empty' | 'banner' | 'info';
    cmaType: 'empty' | 'banner' | 'info';
    cmaOnlineType: 'empty' | 'info';
    style: 'default' | 'modern';
}

export const emptyBrandingInfo = (branding: Branding | null) => !branding || [
    branding.name,
    branding.email,
    branding.personalPhoto,
    branding.companyName,
    branding.companyLogo,
    branding.cellPhone,
    branding.url,
    branding.fax,
    branding.officeLocation,
    branding.officePhone,
    branding.slogan,
].every(i => !i);


export interface UserDetails {
    firstName: string | null;
    lastName: string | null;
    cellPhone: string | null;
    company: string | null;
    profession: string | null;
    homeRegion: string;
    areaOfSpecialization: string | null;
    defaultMapView: MapView | null;
    timezone: string | null;
    signupEpoch: string | null;
    addressLine1: string | null;
    addressLine2: string | null;
    city: string | null;
    country: string | null;
    postalCode: string | null;
    creaTrademarkStatement: string | null;
    showBoardLandingPage: boolean;
}

export interface User {
    uid: string | null;
    username: string | null;
    details: UserDetails;
    avatar: string | null;
    intercom: IntercomData | null;
    subscriptionValid: boolean;
    isAdmin: boolean;
    skillsLearned: string[];
    filledCredentials: string[];
    branding: Branding | null;
    propertiesTableQuotaLeft: number;
    paragonTableQuotaLeft: number;
    offerRentQuotaLeft: number;
    agreements: Record<string, { agreed: number | null; current: number }>;
    disclaimers: Disclaimers;
    sendNotificationsEmail: boolean;
    notificationsRecurrence: number;
    needsSsoRelogin: boolean;
}

export type Disclaimers = { cma?: string };

export type ResourceCredentials = string | Array<string|null> | null;


export const hasCredentials = (resourceCreds: ResourceCredentials | undefined, filledCreds: string[]) =>
    !resourceCreds || (!Array.isArray(resourceCreds) ? [resourceCreds] : resourceCreds).some(c => c === null || filledCreds.includes(c));


export const agrees = (user: User, key: string) => {
    const agreement = user.agreements[key];
    return agreement && agreement.agreed !== null && agreement.agreed >= agreement.current;
};

export const disagrees = (user: User, key: string) => {
    const agreement = user.agreements[key];
    return agreement && agreement.agreed !== null && agreement.agreed <= -1 * agreement.current;
};
